module.exports = __webpack_public_path__ + "img/tela_celular_oferta.9453d921.png";